/**
 * The shape of an error response that {@link getErrorMessages} reads from — typically an
 * axios/HTTP error whose body carries an `errors` array.
 */
export interface ErrorResponse {
	response?: {
		data?: {
			errors?: string[];
		};
	};
}

/**
 * Return an array of error messages from an error response
 * @param response The error response
 */
export function getErrorMessages(response: ErrorResponse): string[] {
	if (!!response.response && !!response.response.data) {
		if (!!response.response.data.errors && Array.isArray(response.response.data.errors)) {
			return response.response.data.errors;
		}

		return [JSON.stringify(response.response.data)];
	}
	return [];
}
